<template>
	<div class="tab-text bg-light-grey">

		<h3 class="mb-4 col-span-3">Alternative Products</h3>

		<div class="vx-row">
			<div class="vx-col w-full lg:w-1/4">
				<div class="vx-card h-100">
					<div class="p-6 flex flex-col h-100">

						<div class="mb-4">
							<h5 class="mb-3 whitespace-nowrap truncate">
								{{ result.tripName }}
							</h5>
							<p class="text-dark-grey">Carnival Splendor</p>
							<p class="text-dark-grey">{{ formatedRestultDate(1) }}</p>
						</div>
						<div class="flex items-center mb-5">
							<vs-progress
								:percent="92"
								color="primary"
							/>
							<span class="text-sm ml-4">92%</span>
						</div>
						<div class="text-sm border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid mb-4 mt-auto">
							<div class="flex items-center text-sm">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current text-primary"
									icon="PlusCircleIcon"
									class="mr-1"
								/>
								<span>Better Service</span>
							</div>
							<div class="flex items-center mb-4">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current text-primary"
									icon="PlusCircleIcon"
									class="mr-1"
								/>
								<span>Save $100 </span>
							</div>
							<div class="flex items-center mb-4">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current "
									icon="MinusCircleIcon"
									class="mr-1"
								/>
								<span>Smaller cabins</span>
							</div>
						</div>
						<div class="flex items-center justify-between">
							Interior<br />
							<span><span class="text-xl">${{ result.totalPrice-100 }}&nbsp;</span> <span class="text-primary">-30%</span></span>
						</div>
					</div>
				</div>
			</div>
			<div class="vx-col w-full lg:w-1/4">
				<div class="vx-card h-100">
					<div class="p-6 flex flex-col h-100">

						<div class="mb-4">
							<h5 class="mb-3 whitespace-nowrap truncate">
								{{ result.duration-2 }} Night {{ result.region }} Cruise
							</h5>
							<p class="text-dark-grey">Brilliance of the Seas</p>
							<p class="text-dark-grey">{{ formatedRestultDate(-1) }}</p>
						</div>
						<div class="flex items-center mb-5">
							<vs-progress
								:percent="93"
								color="primary"
							/>
							<span class="text-sm ml-4">93%</span>
						</div>
						<div class="text-sm border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid mb-4 mt-auto">
							<div class="flex items-center text-sm">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current text-primary"
									icon="PlusCircleIcon"
									class="mr-1"
								/>
								<span>Better Food</span>
							</div>
							<div class="flex items-center mb-4">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current text-primary"
									icon="PlusCircleIcon"
									class="mr-1"
								/>
								<span>Save $50 </span>
							</div>
							<div class="flex items-center mb-4">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current "
									icon="MinusCircleIcon"
									class="mr-1"
								/>
								<span>2 days shorter</span>
							</div>
						</div>
						<div class="flex items-center justify-between">
							Interior<br />
						<span><span class="text-xl">${{ result.totalPrice-50 }}&nbsp;</span> <span class="text-primary">-30%</span></span>
						</div>
					</div>
				</div>
			</div>
			<div class="vx-col w-full lg:w-1/4">
				<div class="vx-card h-100">
					<div class="p-6 flex flex-col h-100">

						<div class="mb-4">
							<h5 class="mb-3 whitespace-nowrap truncate">
								{{ result.tripName }}
							</h5>
							<p class="text-dark-grey">Brilliance of the Seas</p>
							<p class="text-dark-grey">{{ formatedRestultDate(0) }}</p>
						</div>
						<div class="flex items-center mb-5">
							<vs-progress
								:percent="95"
								color="primary"
							/>
							<span class="text-sm ml-4">95%</span>
						</div>
						<div class="text-sm border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid mb-4 mt-auto">
							<div class="flex items-center text-sm">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current text-primary"
									icon="PlusCircleIcon"
									class="mr-1"
								/>
								<span>Better Service</span>
							</div>
							<div class="flex items-center mb-4">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current text-primary"
									icon="PlusCircleIcon"
									class="mr-1"
								/>
								<span>Balcony cabin upgrade</span>
							</div>
							<div class="flex items-center mb-4">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current "
									icon="MinusCircleIcon"
									class="mr-1"
								/>
								<span>Costs $100 more</span>
							</div>
						</div>
						<div class="flex items-center justify-between">
							Interior<br />
							<span><span class="text-xl">${{ result.totalPrice + 100 }}&nbsp;</span> <span class="text-primary">-30%</span></span>
						</div>
					</div>
				</div>
			</div>
			<div class="vx-col w-full lg:w-1/4">
				<div class="vx-card h-100">
					<div class="p-6 flex flex-col h-100">

						<div class="mb-4">
							<h5 class="mb-3 whitespace-nowrap truncate">
								{{ result.tripName }}
							</h5>
							<p class="text-dark-grey">Brilliance of the Seas</p>
							<p class="text-dark-grey">{{ formatedRestultDate(1) }}</p>
						</div>
						<div class="flex items-center mb-5">
							<vs-progress
								:percent="97"
								color="primary"
							/>
							<span class="text-sm ml-4">97%</span>
						</div>
						<div class="text-sm border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid mb-4 mt-auto">
							<div class="flex items-center text-sm">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current text-primary"
									icon="PlusCircleIcon"
									class="mr-1"
								/>
								<span>Better facilities</span>
							</div>
							<div class="flex items-center">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current text-primary"
									icon="PlusCircleIcon"
									class="mr-1"
								/>
								<span>Balcony cabin upgrade</span>
							</div>
							<div class="flex items-center mb-4">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current text-primary"
									icon="PlusCircleIcon"
									class="mr-1"
								/>
								<span>Excellent Service</span>
							</div>

							<div class="flex items-center mb-4">
								<feather-icon
									svgClasses="h-4 w-4 stroke-current "
									icon="MinusCircleIcon"
									class="mr-1"
								/>
								<span>Costs $200 more</span>
							</div>
						</div>
						<div class="flex items-center justify-between">
							Interior<br />
							<span><span class="text-xl">${{ result.totalPrice+200 }}&nbsp;</span> <span class="text-primary">-30%</span></span>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>

</template>

<script>


export default {
  components: {
  },
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  methods: {
	formatedRestultDate(day){
		let d = new Date(this.result.date);
		d.setDate(d.getDate() + day);
		return d.toLocaleString('en-US', { month: 'short', year: 'numeric', day: 'numeric' })
	}
  }
}
</script>
